// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-widgets__items[data-v-58246e68] >div:not(:last-child)>*{margin-bottom:var(--spaces-2xl)}@media(min-width:768px){.home-widgets__items[data-v-58246e68] >div:not(:last-child)>*{margin-bottom:var(--spaces-3xl)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
